import { gql } from "urql";
export const UpdatePublicPriorityEmailRecordMutation = gql `
    mutation UpdatePublicPriorityEmailRecord(
        $input: PublicPriorityEmailRecordUpdateInput!
    ) {
        priorityEmailRecords {
            updatePriorityEmailRecord(input: $input)
        }
    }
`;
